import { ofType } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { CheckoutActions, TypeMap as CheckoutTypeMap } from '@wearejh/m2-pwa-checkout';
import { Observable } from 'rxjs';

import { BasketType } from 'src/queries/__global_generated__/globalTypes';

import { CustomerInfo, isCustomerInfo } from './types';

/**
 * When Guests are using collection, we need to use the
 * a custom event to trigger the start checkout event.
 */
export function guestCollectionEpic(action$, state$): Observable<CustomerInfo> {
    return action$.pipe(
        ofType<CheckoutActions, CheckoutTypeMap['Checkout.SetPendingPayment']>('Checkout.SetPendingPayment'),

        withLatestFrom(state$),

        // Only trigger when the user is not logged in and using collection.
        filter(
            ([, state]) =>
                state.user?.session !== 'SignedIn' && state.cart?.raw?.woodies?.basket_type === BasketType.COLLECT,
        ),

        map(([action]: [CheckoutTypeMap['Checkout.SetPendingPayment']]) => {
            const billingAddress = action.payload?.billingAddress;

            const email = billingAddress?.email;
            const firstName = billingAddress?.firstname;
            const lastName = billingAddress?.lastname;

            if (email && firstName && lastName) {
                const customerInfo: CustomerInfo = {
                    email,
                    firstName,
                    isGuest: true,
                    lastName,
                };

                return customerInfo;
            }

            return null;
        }),

        // Filter out null values
        filter(isCustomerInfo),
    );
}
